// extracted by mini-css-extract-plugin
export default {"healthRiskFilter":"HealthRiskFilter_healthRiskFilter__h7O0j","healtRiskMenuItem":"HealthRiskFilter_healtRiskMenuItem__cGP17"};